//
//
//
//
//
//
//
//
//

export default {
  props: {
    disabled: {
      type: Boolean
    }
  }
};
